import { DefaultTabuUtilsConfig, TabuUtilsConfig } from "@10x/tabu-mobile-api/dist/requests/utils-config";
import { ProcedureIDs } from "@10x/tabu-mobile-api/dist/requests/entity";

TabuUtilsConfig.resendAllowedProcedures = [ ...DefaultTabuUtilsConfig.resendAllowedProcedures, ProcedureIDs.PROPERTY_VALUATION ];
